import './style.scss';

type Props = {
  steps: string[];
  title?: string;
  activeStepId: number;
  onClick?: (index: number) => void;
};

export const Stepper = ({ steps, activeStepId }: Props) => {

  return (
    <div className="steps">
      <ul className="steps-list">
        {steps.map((step, idx) => (
          <li className={`steps-list-item  
            ${activeStepId > idx ? 'completed' : activeStepId === idx ? 'current' : ''}`}>
            <span></span>
            <b className='stepLabel'>{step}</b>
          </li>
        ))}
      </ul>
    </div>
  );
};
